module.exports = __webpack_public_path__ + "static/media/ezgif.com-webp-to-jpg (1).55578390.jpg";